var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveSwitchRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.086148, 0, 0, 1.016611, -15.462266, 0.687036)",
    style: {},
    fill: "rgba(43, 51, 63, 0.7)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.541,490V0l458.917,245.009L15.541,490z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1, 0, 0, -1, 485.272461, 494.41861)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveSwitchRight);
export default __webpack_public_path__ + "static/media/live_switch_right.c21751580830f2857426080ba2022114.svg";
export { ForwardRef as ReactComponent };